export default {
  page_title: 'Other LIIs and Resources',
  t_falm: 'FALM Members',
  t_clic: 'CLIC Sites',
  clicname: 'Community Legal Information Centre',
  liis: [
    "HKLII participates in the {0}, a grouping of the following organisations:",
    "CLIC is a bilingual community legal information web-site. It is a quick internet guide for the general public to find relevant legal information in Hong Kong. The project is established by the Law &amp; Technology Centre (jointly run by the Faculty of Law and the Department of Computer Science) of the University of Hong Kong."
  ],
  fatlm: "Free Access to Law Movement"
}